import type { SelectHTMLAttributes } from "react";
import { cn } from "../lib/cn";

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export function Select({ className, ...props }: SelectProps) {
  return <select className={cn("cf-input", className)} {...props} />;
}
